module.exports = __webpack_public_path__ + "eec453e463ced65df4e1fa9c23f55b35.svg";